import {TaskRepetitionUnit, taskRepetitionUnits} from '@hconnect/common/types'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

export const RecurrenceFilterDropDown: React.FC<CommonFilterDropDownProps<TaskRepetitionUnit>> = (
  props
) => {
  const {selectAll} = props
  return (
    <FilterDropDown
      {...props}
      options={taskRepetitionUnits}
      keyName="repetition"
      fullWidth={false}
      customDropDownFooter={(keyName) =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={keyName}
              selectAll={() =>
                selectAll &&
                selectAll(keyName, taskRepetitionUnits as unknown as TaskRepetitionUnit[])
              }
            />
            <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
